import React, { useState } from 'react';
import styled from 'styled-components';
import PARTICIPATE from '../../assets/participate.jpg';

const StatsSection = styled.section`
  background: linear-gradient(135deg, #020611 0%, #050B15 50%, #020611 100%);  
  display: flex;
  align-items: center;
  font-family: Very Sans, Sans Serif;
  padding: 90px 0px;
`;

const StatsContainer = styled.div`
  width: 80%;
  height: 400px;
  text-align: center;
  margin: 0 auto;
  background: url(${PARTICIPATE});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StatsContainerInner = styled.div`
  width: 85%;
  height: 85%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 24px;
  color: white;
  font-family: Very Sans Headline, Sans Serif;
`;

const FeatureButtonRow = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const FeatureButton = styled.button`
  border: none;
  padding: 10px 15px;
  background: rgba(59, 130, 246, 0.25);
  border-radius: 5px;
  color: #ffffff;
  cursor: pointer;
  font-family: Very Sans, Sans Serif;
  font-size: 15px;

  &:hover {
    background: rgba(59,130,246,1);
  }
`;

const AnimatedDescription = styled.div`
  
  padding-top: 7.5px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  line-height: 1.5;

  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: translateX(${({ visible }) => (visible ? "0" : "-30px")});
  transition: all 0.4s ease;
`;

const descriptions = {
  Community: "Join in and engage with the Hydrix community.",
  Mine: "Start mining instantly with one tap — simple, fast, secure.",
  Nodes: "Run a Hydrix node and help support our decentralized network.",
  Create: "Build tools and utilities to help you build on Hydrix.",
  Explore: "See whats going on, on-chain right now."
};

const Participate = () => {
  const [activeFeature, setActiveFeature] = useState(null);

  return (
    <StatsSection>
      <StatsContainer>
        <StatsContainerInner>
          <SectionTitle>Anyone Can Participate</SectionTitle>

          <AnimatedDescription visible={!!activeFeature}>
            {activeFeature ? descriptions[activeFeature] : ""}
          </AnimatedDescription>

          <FeatureButtonRow>
            {Object.keys(descriptions).map((label) => (
              <FeatureButton
                key={label}
                onMouseEnter={() => setActiveFeature(label)}
                onMouseLeave={() => setActiveFeature(null)}
              >
                {label}
              </FeatureButton>
            ))}
          </FeatureButtonRow>
        </StatsContainerInner>
      </StatsContainer>
    </StatsSection>
  );
};

export default Participate;
